export const buildHighRiskSupplementsSearchPayload = ({
  page,
  searchValue,
  selectedCategory,
}: any) => ({
  pagedResultsRequest: {
    pagination: {
      page,
      pageSize: Number(process.env.REACT_APP_PAGE_SIZE_FOR_USER_INQUIRIES_TABLE) || 10,
    },
    search: searchValue,
    sort: {
      active: '',
      direction: '',
    },
  },
  ...(Boolean(selectedCategory) && { riskSupplementCategoryId: selectedCategory }),
});
